import { getAxiosInstance } from '../client';
/** Typed API functions for authentication */
export const authQueries = {
    /** GET /auth/offices — the Account's offices, resolved from the token alone (#1822). */
    listOffices: () => getAxiosInstance()
        .get('/auth/offices')
        .then((r) => r.data),
};
/** Query keys for auth domain - use with TanStack Query */
export const authKeys = {
    all: () => ['auth'],
    verifyEmailUpdate: (token) => ['auth', 'verify-email-update', token],
};
//# sourceMappingURL=auth.queries.js.map